import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
import { jsS, extend } from "@pnp/common";
var Planner = /** @class */ (function (_super) {
    tslib_1.__extends(Planner, _super);
    function Planner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Planner.prototype, "plans", {
        // Should Only be able to get by id, or else error occur
        get: function () {
            return new Plans(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Planner.prototype, "tasks", {
        // Should Only be able to get by id, or else error occur
        get: function () {
            return new Tasks(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Planner.prototype, "buckets", {
        // Should Only be able to get by id, or else error occur
        get: function () {
            return new Buckets(this);
        },
        enumerable: true,
        configurable: true
    });
    Planner = tslib_1.__decorate([
        defaultPath("planner")
    ], Planner);
    return Planner;
}(GraphQueryableInstance));
export { Planner };
var Plans = /** @class */ (function (_super) {
    tslib_1.__extends(Plans, _super);
    function Plans() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Plans.prototype.getById = function (id) {
        return new Plan(this, id);
    };
    /**
     * Create a new Planner Plan.
     *
     * @param owner Id of Group object.
     * @param title The Title of the Plan.
     */
    Plans.prototype.add = function (owner, title) {
        var _this = this;
        var postBody = {
            owner: owner,
            title: title,
        };
        return this.postCore({
            body: jsS(postBody),
        }).then(function (r) {
            return {
                data: r,
                plan: _this.getById(r.id),
            };
        });
    };
    Plans = tslib_1.__decorate([
        defaultPath("plans")
    ], Plans);
    return Plans;
}(GraphQueryableCollection));
export { Plans };
/**
 * Should not be able to get by Id
 */
var Plan = /** @class */ (function (_super) {
    tslib_1.__extends(Plan, _super);
    function Plan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Plan.prototype, "tasks", {
        get: function () {
            return new Tasks(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Plan.prototype, "buckets", {
        get: function () {
            return new Buckets(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Plan.prototype, "details", {
        get: function () {
            return new Details(this);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Deletes this Plan
     */
    Plan.prototype.delete = function () {
        return this.deleteCore();
    };
    /**
     * Update the properties of a Plan
     *
     * @param properties Set of properties of this Plan to update
     */
    Plan.prototype.update = function (properties, eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return this.patchCore({
            body: jsS(properties),
            headers: {
                "If-Match": eTag,
            },
        });
    };
    return Plan;
}(GraphQueryableInstance));
export { Plan };
var Tasks = /** @class */ (function (_super) {
    tslib_1.__extends(Tasks, _super);
    function Tasks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tasks.prototype.getById = function (id) {
        return new Task(this, id);
    };
    /**
     * Create a new Planner Task.
     *
     * @param planId Id of Plan.
     * @param title The Title of the Task.
     * @param assignments Assign the task
     * @param bucketId Id of Bucket
     */
    Tasks.prototype.add = function (planId, title, assignments, bucketId) {
        var _this = this;
        var postBody = {
            planId: planId,
            title: title,
        };
        if (assignments) {
            postBody = extend(postBody, {
                assignments: assignments,
            });
        }
        if (bucketId) {
            postBody = extend(postBody, {
                bucketId: bucketId,
            });
        }
        return this.postCore({
            body: jsS(postBody),
        }).then(function (r) {
            return {
                data: r,
                task: _this.getById(r.id),
            };
        });
    };
    Tasks = tslib_1.__decorate([
        defaultPath("tasks")
    ], Tasks);
    return Tasks;
}(GraphQueryableCollection));
export { Tasks };
var Task = /** @class */ (function (_super) {
    tslib_1.__extends(Task, _super);
    function Task() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Deletes this Task
     *
     * @param eTag Up to date eTag of Task to update
     */
    Task.prototype.delete = function (eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return this.deleteCore({
            headers: {
                "If-Match": eTag,
            },
        });
    };
    /**
     * Update the properties of a Task
     *
     * @param properties Set of properties of this Task to update
     * @param eTag Up to date eTag of Task to update
     */
    Task.prototype.update = function (properties, eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return this.patchCore({
            body: jsS(properties),
            headers: {
                "If-Match": eTag,
            },
        });
    };
    Object.defineProperty(Task.prototype, "details", {
        get: function () {
            return new Details(this);
        },
        enumerable: true,
        configurable: true
    });
    return Task;
}(GraphQueryableInstance));
export { Task };
var Buckets = /** @class */ (function (_super) {
    tslib_1.__extends(Buckets, _super);
    function Buckets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new Bucket.
     *
     * @param name Name of Bucket object.
     * @param planId The Id of the Plan.
     * @param oderHint Hint used to order items of this type in a list view.
     */
    Buckets.prototype.add = function (name, planId, orderHint) {
        var _this = this;
        var postBody = {
            name: name,
            orderHint: orderHint ? orderHint : "",
            planId: planId,
        };
        return this.postCore({
            body: jsS(postBody),
        }).then(function (r) {
            return {
                bucket: _this.getById(r.id),
                data: r,
            };
        });
    };
    Buckets.prototype.getById = function (id) {
        return new Bucket(this, id);
    };
    Buckets = tslib_1.__decorate([
        defaultPath("buckets")
    ], Buckets);
    return Buckets;
}(GraphQueryableCollection));
export { Buckets };
var Bucket = /** @class */ (function (_super) {
    tslib_1.__extends(Bucket, _super);
    function Bucket() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Deletes this Bucket
     */
    Bucket.prototype.delete = function () {
        return this.deleteCore();
    };
    /**
     * Update the properties of a Bucket
     *
     * @param properties Set of properties of this Bucket to update
     */
    Bucket.prototype.update = function (properties, eTag) {
        if (eTag === void 0) { eTag = "*"; }
        return this.patchCore({
            body: jsS(properties),
            headers: {
                "If-Match": eTag,
            },
        });
    };
    Object.defineProperty(Bucket.prototype, "tasks", {
        get: function () {
            return new Tasks(this);
        },
        enumerable: true,
        configurable: true
    });
    return Bucket;
}(GraphQueryableInstance));
export { Bucket };
var Details = /** @class */ (function (_super) {
    tslib_1.__extends(Details, _super);
    function Details() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Details = tslib_1.__decorate([
        defaultPath("details")
    ], Details);
    return Details;
}(GraphQueryableCollection));
export { Details };
//# sourceMappingURL=planner.js.map